import { IExportPatternInfo, IPmExportPatternInfo } from '@blcloud/bl-datamodel';

export interface IExportPatternModalParams {
  exportPatternCode: string | number;
  exportInfoDiv: string | number;
  dataModalExportPatterns: IExportPatternInfo;
  exportInfoTabDiv: string | number;
}

/**
 * 出力パターンモーダル結果
 */
export interface IExportPatternModalResult {
  /** テキスト出力パターン情報 */
  exportPatternInfo?: IPmExportPatternInfo;
}

/**
 * 出力パターンコード
 */
export class ExportPatternCodeConstant {
  /** 請求残高PDF出力パターンコード */
  public static readonly PATTERN_CODE_ALL_ITEM_BILLING = '192';
  /** 売掛残高(与信残高あり)PDF出力パターンコード */
  public static readonly PATTERN_CODE_ALL_ITEM_ACCREC_BALANCE = '193';
  /** 売掛残高(与信残高なし)PDF出力パターンコード */
  public static readonly PATTERN_CODE_ALL_ITEM_ACCREC_NOBALANCE = '194';
  /** 支払残高PDF出力パターンコード */
  public static readonly PATTERN_CODE_ALL_ITEM_PAY = '188';
  /** 買掛残高PDF出力パターンコード */
  public static readonly PATTERN_CODE_ALL_ITEM_ACCPAY = '189';
}



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/export-pattern-modal/export-pattern-modal.define.ts